<template>
  <v-app id="app">
    <router-view name="navbar" ref="navbar" :activeTag="activeTag"></router-view>
    <router-view ref="main"></router-view>
    <router-view name="info" ref="info"></router-view>
    <router-view name="experience" ref="experience"></router-view>
    <router-view name="contact" ref="contact"></router-view>
    <router-view name="footer"></router-view>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      activeTag: null
    };
  },
  mounted() {
    document.addEventListener("touchmove", this.handleScroll, true);
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    document.addEventListener("touchmove", this.handleScroll, true);
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      let offset = window.pageYOffset + window.innerHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      if (this.$refs.length !== 0) {
        let navbarHeight = this.$refs.navbar.$el.offsetHeight;
        Object.keys(this.$refs).forEach(data => {
          if (
            window.pageYOffset + navbarHeight >=
            this.$refs[data].$el.offsetTop
          ) {
            this.activeTag = this.$refs[data].$el.id;
          } else if (scrollHeight === offset) {
            this.activeTag = "contact";
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
html,
body {
  width: 100vw;
  font-family: "consolas";
  margin: 0px;
  padding: 0px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
#app {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue